/**
 * Sets an expiring Object or string to localStorage
 * @param key localStorage key
 * @param value string or object that you want to store
 * @param ttl Time to live in milliseconds until it expires
 */
export const setWithExpiry = (key: string, value: string | Object, ttl: number) => {
  const now = new Date();

  const valueObject: { value?: Object; expiry?: number } = {};
  valueObject.value = value;
  valueObject.expiry = now.getTime() + ttl;

  localStorage.setItem(key, JSON.stringify(valueObject));
};

/**
 * Returns a value from localStorage that has been set with setWithExpiry if it hasn't expired yet.
 * Otherwise the item is deleted from localStorage and null is returned
 */
export const getWithExpiry = (key: string) => {
  const itemStr = localStorage.getItem(key);

  if (!itemStr) {
    return null;
  }

  try {
    const item = JSON.parse(itemStr);
    const now = new Date();

    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }

    return item.value;
  } catch {
    localStorage.removeItem(key);
    return null;
  }
};
